import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './components/ui/ToastContainer';
import PrivateRoute from './components/auth/PrivateRoute';
import Layout from './components/layout/Layout';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import RoomListPage from './pages/RoomListPage';
import RoomLobbyPage from './pages/RoomLobbyPage';
import GamePage from './pages/GamePage';
import GameRoomPage from './pages/GameRoomPage';
import StatsPage from './pages/StatsPage';
import CodexPage from './pages/CodexPage';

function App() {
  return (
    <Router>
      <ToastProvider>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <Layout>
                    <RoomListPage />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/rooms"
              element={
                <PrivateRoute>
                  <Layout>
                    <RoomListPage />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/rooms/:roomId/lobby"
              element={
                <PrivateRoute>
                  <Layout>
                    <RoomLobbyPage />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/rooms/:roomId/game"
              element={
                <PrivateRoute>
                  <GameRoomPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/rooms/:roomId/game-old"
              element={
                <PrivateRoute>
                  <Layout>
                    <GamePage />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/stats"
              element={
                <PrivateRoute>
                  <Layout>
                    <StatsPage />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/codex"
              element={
                <PrivateRoute>
                  <Layout>
                    <CodexPage />
                  </Layout>
                </PrivateRoute>
              }
            />
          </Routes>
        </AuthProvider>
      </ToastProvider>
    </Router>
  );
}

export default App;
